<td class="text-center grey">
    <p class="text-uppercase">{{reg.publicRegIdentifier}}</p>
    <p>{{reg.testTypeName}}</p>
    <small>Registered on {{reg.registrationDate | date:'mediumDate' }}</small>
    <div *ngIf="reg.regStatusEnum === RegStatusEnum.RegistrationActive && reg.isInCancelledTestSession === true">
        <strong style="color: red; font-size:larger">
            Your {{BrandEnum[brandId]}} Test has been cancelled. Please contact Paragon to transfer your test to another date.
        </strong>
    </div>
    <div
        class="dropdown"
        *ngIf="!reg.isCancelledOrRefunded && reg.isScoreReportSupported"
    >
        <app-test-actions [reg]="reg"></app-test-actions>
    </div>
    <div
        class="btn-group"
        *ngIf="reg.isScoreReportSupported && reg.areScoresReleased == true && reg.regStatusEnum === RegStatusEnum.ScorePublished || reg.regStatusEnum === RegStatusEnum.ScoreInvalidated"
    >
        <br />
        <a
            (click)="downloadScoreReportUrl(reg)"
            class="btn btn-primary"
        ><span><i class="fa fa-file-text-o"></i></span> Check Scores</a>
    </div>
    <div *ngIf="complaintSubmissionDate"><small>Complaint submitted on {{complaintSubmissionDate | date: 'longDate'}} (Time Zone: {{localTimeZone}})</small></div>
    <div *ngIf="!reg.isScoreReportSupported && reg.regStatusEnum === RegStatusEnum.ScorePublished">
        <small class="text-center">Scores are only made available to test takers for a period of {{reg.yearsLimitForScoreReportSupport}} years from the day of the test.</small>
    </div>
    <div *ngIf="reg?.userAccountReevaluationRequest?.allRevaluationComplete && reg.isScoreReportSupported">
        <br />
        <small>Your re-evaluation is complete.</small>
        <small> Please click "Check Scores" to view your updated scores.</small>
    </div>
    <div *ngIf="!reg?.userAccountReevaluationRequest?.allRevaluationComplete && reevaluationSubmissionDate && reg.isScoreReportSupported">
        <br />
        <small>
            Re-evaluation requested on
            {{ reevaluationSubmissionDate | date: 'longDate'}} (Time Zone: {{localTimeZone}}).
        </small>
        <small>Your re-evaluation will be completed within 1-2 weeks.</small>
    </div>
    <div *ngIf="reg.regStatusEnum === RegStatusEnum.RegistrationManualApprovalRequired">
        <br />
        <strong>Pending Approval</strong>
    </div>
    <div *ngIf="reg.isCancelledOrRefunded === true">
        <br />
        <strong>Registration Cancelled</strong>
    </div>
    <div *ngIf="reg.areScoresReleased === false && reg.isScoreReportSupported && reg.regStatusEnum === RegStatusEnum.ScorePublished">
        <br />
        <strong style="color: red">These scores are being held. If you have any questions, please <a
                style="text-decoration:underline;"
                href="https://www.{{brandName}}.ca/about-us/contact-us/"
            >contact us</a>.</strong>
    </div>
</td>
<td class="text-center">
    <div *ngIf="brandId === BrandEnum.CELPIP">{{testDate | customDate: 'formatDateTime' }}</div>
    <div *ngIf="brandId === BrandEnum.CAEL">{{testDate | date: 'fullDate'}}</div>
    <div *ngIf="reg.isWebDelivery">
        <small *ngIf="reg.isWebDelivery">(Time Zone: {{localTimeZone}})</small>
        <small>{{reg.testTypeName}}</small>
    </div>
    <div *ngIf="!reg.isWebDelivery">
        <small>{{reg.testCentreName}}</small>
        <small class="white-space-pre">{{reg.testCentreLocation}}</small>
    </div>
    <div *ngIf="reg.testCentreUrl && reg.testCentreUrl?.length>0">
        <br />
        <a
            *ngIf="(brandId === BrandEnum.CELPIP || reg.brandTestTypeId === caelCETestTypeId) && (reg.regStatusEnum === RegStatusEnum.RegistrationActive)"
            (click)="resendEmail(reg)"
            class="info-url"
        >Resend Test Confirmation Email</a>
        <br />
        <a
            href={{testDayInfoUrl}}
            target="_blank"
        >Test Day Procedures</a>
        <br />
        <a
            href={{regPoliciesUrl}}
            target="_blank"
        >Cancellation, Transfer, and Retake Policies</a>
    </div>
</td>


<!--Modal Body-->
<ng-template
    #content
    let-modal
>
    <div
        class="modal-header"
        style="background-color:#A6192E"
    >
        <h5
            class="modal-title text-center"
            style="color:white"
        >Document Ready</h5>
    </div>
    <div class="modal-body text-center">
        <span>Click <a
                style="color:#A6192E"
                (click)="hideAndDownload()"
            >here</a> to download file</span>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('ok click');"
        >close</button>
    </div>
</ng-template>
